// Icones da ficha do produto (spec 2026-09-23), SVG inline no mesmo estilo de
// IconeCaixaVazia da TelaPedido -- sem biblioteca de icones nova.
type P = { tamanho?: number }
const base = (t: number) => ({
  viewBox: '0 0 24 24', width: t, height: t, fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.8, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true,
})

export function IconeCaixa({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M21 8 12 3 3 8v8l9 5 9-5V8Z" /><path d="M3 8l9 5 9-5" /><path d="M12 13v8" /></svg>
}
export function IconeEtiqueta({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z" /><circle cx="7.5" cy="7.5" r="1.5" /></svg>
}
export function IconePredio({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" /><path d="M16 9h2a2 2 0 0 1 2 2v10" /><path d="M3 21h18M8 7h4M8 11h4M8 15h4" /></svg>
}
export function IconeMoedas({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><ellipse cx="9" cy="6" rx="6" ry="3" /><path d="M3 6v4c0 1.7 2.7 3 6 3s6-1.3 6-3V6" /><path d="M9 16c-3.3 0-6-1.3-6-3v4c0 1.7 2.7 3 6 3 1.4 0 2.7-.2 3.7-.6" /><circle cx="17" cy="16" r="4" /></svg>
}
export function IconeDocumento({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z" /><path d="M14 3v6h6M8 13h8M8 17h5" /></svg>
}
export function IconeGrafico({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M3 21h18M6 17v-5M11 17V8M16 17v-8M21 17V5" /></svg>
}
export function IconeRelogio({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5M12 7v5l3 2" /></svg>
}
export function IconeLapis({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
}
export function IconeCompartilhar({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4" /></svg>
}
export function IconeCarrinho({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><circle cx="9" cy="20" r="1.5" /><circle cx="18" cy="20" r="1.5" /><path d="M2 3h3l2.7 12.4a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.6L22 7H6" /></svg>
}
export function IconePorcento({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M19 5 5 19" /><circle cx="6.5" cy="6.5" r="2.5" /><circle cx="17.5" cy="17.5" r="2.5" /></svg>
}
export function IconeCamera({ tamanho = 20 }: P) {
  return <svg {...base(tamanho)}><path d="M14.5 4h-5L8 6H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-4l-1.5-2Z" /><circle cx="12" cy="12.5" r="3.5" /></svg>
}
